// Hacky wraper for jquery slider pips.
import * as React from "react";
export class Slider extends React.Component {
    constructor(props) {
        super(props);
        this.ref = React.createRef();
        this.suspendUpdates = false;
        this.state = { value: props.initialValue };
    }
    // Called when slider changed by setting a value.
    onChange(value) {
        if (this.suspendUpdates)
            return;
        if (this.state.value == value)
            return;
        this.props.onEnd(this.props.initialValue, value);
        this.setState({ value: value });
    }
    onSlideStart(_) {
        var _a;
        if (this.suspendUpdates)
            return;
        (_a = this.props.onStart) === null || _a === void 0 ? void 0 : _a.call(null);
    }
    // Called when slider changed by sliding
    onSlide(value) {
        if (this.suspendUpdates)
            return;
        this.props.onChange(value);
    }
    /** Called when the user has stopped interacting with slider by sliding. */
    onSlideStop(value) {
        if (this.suspendUpdates)
            return;
        // Component could have died, check that state is valid.
        if (this.state) {
            this.setState({ value: value });
            this.props.onEnd(this.props.initialValue, value);
        }
    }
    componentDidUpdate(prevProps, prevState) {
        if (prevProps.initialValue != this.props.initialValue) {
            if (prevState.value != this.props.initialValue) {
                // Props updated externally. Update current state but don't invoke any callbacks.
                this.setState({
                    value: this.props.initialValue
                });
                // Update the slider.
                this.suspendUpdates = true;
                let slider = $(this.ref.current);
                slider.slider({ value: this.props.initialValue });
                this.suspendUpdates = false;
            }
        }
    }
    componentDidMount() {
        // Unfortunately pips does not have typedefs so without cast to <any>
        // the rest would not compile.
        let slider = $(this.ref.current);
        // jQuery will override this in components
        var self = this;
        this.setState({ value: this.props.initialValue });
        slider.slider({
            min: this.props.min,
            max: this.props.max,
            range: "min",
            value: this.props.initialValue,
            step: this.props.step || 1.0,
            animate: "fast"
            // orientation: "vertical"
            // }).slider("float", {
            //     formatLabel: this.props.formatLabel || (v => v)
        }).on("slidechange", function (_, ui) {
            self.onChange(ui.value);
        }).on("slidestart", function (_, ui) {
            self.onSlideStart(ui.value);
        }).on("slide", function (_, ui) {
            self.onSlide(ui.value);
        }).on("slidestop", function (_, ui) {
            self.onSlideStop(ui.value);
        });
        if (this.props.pipsStep) {
            slider.slider("pips", {
                first: false,
                last: false,
                rest: "pip",
                step: this.props.pipsStep,
            });
        }
    }
    componentWillUnmount() {
        // Permanently suspend updates.
        this.suspendUpdates = true;
        let slider = $(this.ref.current);
        slider.off("slidestart");
        slider.off("slidechange");
        slider.off("slide");
        slider.off("slidestop");
    }
    render() {
        var _a;
        return React.createElement("div", { className: "slider " + ((_a = this.props.extraClass) !== null && _a !== void 0 ? _a : ""), ref: this.ref });
    }
}
